import { Injectable, signal } from '@angular/core';
import { httpResource, HttpContext } from '@angular/common/http';
import { RecipientSearch } from '../models/message.model';
import { LOADER_CONTEXT } from '@app/shared/utils/constants';

@Injectable({
  providedIn: 'root'
})
export class RecipientSearchService {

  readonly query = signal('');

  readonly recipientsResource = httpResource<RecipientSearch>(
    () => {
      const search = this.query().trim();

      if (search.length < 2) {
        return undefined;
      }

      return {
        url: '/api/recipients',
        params: {
          search
        },
        context: new HttpContext().set(LOADER_CONTEXT,'local')
      };
    }
  );
}